var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCartIcon = function SvgCartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 20",
    fill: "none",
    stroke: "#4D5055",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0265 3.85055C14.5414 3.85055 11.5528 3.85055 15.5751 3.85055C19.5973 3.85055 20.6993 3.85055 19.5973 9.3244C18.5201 14.6751 18.8584 14.5192 13.6093 14.5012C13.414 14.5005 12.2111 14.5 12 14.5C6 14.5 6.84206 13.9843 5.52502 8.2145C3.8782 1 4.96972 1 1 1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5001 17.3501C7.86494 17.3501 7.3501 17.865 7.3501 18.5001C7.3501 19.1351 7.86494 19.6501 8.5001 19.6501C9.13526 19.6501 9.6501 19.1351 9.6501 18.5001C9.6501 17.865 9.13526 17.3501 8.5001 17.3501ZM17.5001 17.3501C16.865 17.3501 16.3501 17.865 16.3501 18.5001C16.3501 19.1352 16.865 19.6501 17.5001 19.6501C18.1352 19.6501 18.6501 19.1352 18.6501 18.5001C18.6501 17.865 18.1352 17.3501 17.5001 17.3501Z",
    fill: "#4D5055"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart_icon.04d17fe7.svg";
export { ForwardRef as ReactComponent };